import React from 'react';

const Search = ({color}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24.005" height="24.006" viewBox="0 0 24.005 24.006">
  <path id="Path_75" data-name="Path 75" d="M1344.327,138.01l2.84,2.84a2.531,2.531,0,0,0,.63,2.446l3.587,3.588a2.569,2.569,0,0,0,3.633-3.633l-3.587-3.588a2.532,2.532,0,0,0-2.447-.629l-2.84-2.841a7.945,7.945,0,1,0-1.816,1.817Zm-.816-2.633a5.378,5.378,0,1,1,0-7.606A5.384,5.384,0,0,1,1343.511,135.377Z" transform="translate(-1331.765 -123.631)" fill="#fff"/>
</svg>

    )
}

export default Search;